import styled from 'styled-components'

const Container = styled.table`
  border-collapse: collapse;
  width: 100%;
`

export default Container
